var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "registerAgreement" }, [
    _c("div", { staticClass: "title-back" }, [
      _c(
        "p",
        { staticClass: "back", on: { click: _vm.goback } },
        [_c("md-icon", { attrs: { name: "arrow-left", size: "md" } })],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "title" }, [_vm._v("飞鹤用户注册协议")])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _vm._m(7),
    _vm._v(" "),
    _vm._m(8),
    _vm._v(" "),
    _vm._m(9)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rulename" }, [
      _c("p", { staticClass: "content" }),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "欢迎您成为飞鹤的用户！在您成功注册之前，请仔细阅读下面的协议，只有接受协议才能继续进行账户激活。"
        )
      ]),
      _vm._v(" "),
      _c("p")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rulename" }, [
      _c("h4", { staticClass: "small_title" }, [
        _vm._v("一、条款的确认及接受")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "content" }),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "1、飞鹤网站指飞鹤集团下的feihe.com（包括PC端和手机端）、飞鹤官方商城微信小程序、和飞鹤星妈会微信公众号中的网站（星妈优选、奶娃百科、星妈课堂），以下称“本网站”。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "2、上述网站的所有权和运营权归属黑龙江飞鹤乳业有限公司及黑龙江飞鹤电子商务有限公司（下称；飞鹤公司及飞鹤电商或我们）所有。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "3、本网站提供的服务将完全按照其发布的服务条款和操作规则严格执行。您确认所有协议条款并完成注册程序时，本协议在您与本网站间成立并发生法律效力，同时您成为本网站正式用户。请您务必审慎阅读、充分理解本协议中各条款内容。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "4、根据国家法律法规变化及本网站运营需要，我们有权对本协议条款及相关规则不时地进行修改，修改后的内容一旦以任何形式公布在本网站上即生效，并取代此前相关内容，您应不时关注本网站公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用本网站；如您继续使用本网站，即视为知悉变动内容并同意接受。"
        )
      ]),
      _vm._v(" "),
      _c("p")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rulename" }, [
      _c("h4", { staticClass: "small_title" }, [_vm._v("二、服务须知")]),
      _vm._v(" "),
      _c("p", { staticClass: "content" }),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v("1.基于本网站所提供服务的重要性，您确认并同意：")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "a)提供的注册资料真实、准确、完整、合法有效，注册资料如有变动的，应及时更新。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "b)如果您提供的注册资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且飞鹤保留终止您使用本网站各项服务的权利。"
        )
      ]),
      _vm._v(" "),
      _c("p")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rulename" }, [
      _c("h4", { staticClass: "small_title" }, [_vm._v("三、账户注册与使用")]),
      _vm._v(" "),
      _c("p", { staticClass: "content" }),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "1、在您开始本网站注册程序前您确认：您具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述相适应的民事行为能力，则您及您的监护人应依照法律规定承担法律后果。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "2、当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得飞鹤账户并成为飞鹤会员。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "3、本网站可以将您注册的账号共享给飞鹤公司及飞鹤电商旗下的其他对外服务平台，您可以通过注册的账户登录飞鹤公司及飞鹤电商旗下的所有对外服务网站。"
        )
      ]),
      _vm._v(" "),
      _c("p")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rulename" }, [
      _c("h4", { staticClass: "small_title" }, [
        _vm._v("四、用户个人信息保护及授权")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "content" }),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "1、您知悉并同意，为方便您使用本网站相关服务，本网站将存储您在使用时的必要信息，包括但不限于您的真实姓名、性别、生日、配送地址、联系方式、定位信息等。除法律法规规定的情形外，未经您的许可我们不会向非飞鹤集团所属的第三方公开、透露您的个人信息。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "2、在使用本网站某些特点服务时，需要您提供特定信息（例如：您孩子的出生证明），本网站会存储这些信息。除法律法规规定的情形外，未经您的许可我们不会向非飞鹤集团所属的第三方公开、透露您的特定信息。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v("3、您可以通过本网站维护您的部分信息。")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "4、本网站将使用相应的技术，防止您的个人资料丢失、被盗用或遭篡改。但请注意在因特网上不存在“完善的安全措施”，因此我们不承诺上述资料绝对安全。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "5、一旦成功成为网站用户，您将得到一个密码和账号。请谨慎保管您的账号及密码，因疏于保管账号密码造成的后果由用户自己承担。另外，每个用户都要对其账户中的所有活动和事件负全责。您可根据实际情况随时改变您的密码。用户若发现任何非法使用用户账户和安全漏洞的情况，请立即通知我们。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [_vm._v("6、您充分理解并同意：")]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "a)接收通过邮件、短信、公众号消息、电话等形式，向在本网站注册、购物的用户、收货人发送的订单信息、促销活动等内容。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "b)飞鹤依法保障您在安装或使用过程中的知情权和选择权，在您使用本网站服务过程中，涉及您设备自带功能的服务会提前征得您同意，您一经确认，飞鹤有权开启包括但不限于收集地理位置、使用摄像头等，提供服务必要的辅助功能。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "c)飞鹤有权根据实际情况，在法律规定范围内自行决定单个用户在本网站及服务中数据的最长储存期限以及用户日志的储存期限，并在服务器上为其分配数据最大存储空间等。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rulename" }, [
      _c("h4", { staticClass: "small_title" }, [_vm._v("五、Cookies的使用")]),
      _vm._v(" "),
      _c("p", { staticClass: "content" }),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "1、本网站会使用Cookies,以便于能够为您提供更加周到的个性化服务。当您登陆我们的网站时，本网站会使用Cookies存储相关信息，追访您的个人喜好、使用习惯，使我们的网站在您再次访问时可以辨认您的身份，为您提供更好的服务。你也可以关闭此项功能，本网站将停止Cookies为您提供的服务。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rulename" }, [
      _c("h4", { staticClass: "small_title" }, [_vm._v("六、关于网络分销")]),
      _vm._v(" "),
      _c("p", { staticClass: "content" }),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "1、本网站只发展线上分销，拒绝任何形式的线下销售，禁止以加盟线上之名行线下销售之实，所有网络分销商不得低价（低于网络分销商限价销售，具体价格以每次公开为准）、窜货（囤货至线下门店销售），如有违反，本网站有权单反面取消所有未付营销补贴，严重者同时取消所有合作，飞鹤有权单方面终止与商家网络分销合作。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rulename" }, [
      _c("h4", { staticClass: "small_title" }, [_vm._v("七、用户行为规范")]),
      _vm._v(" "),
      _c("p", { staticClass: "content" }),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "1、本协议依据国家相关法律法规规章制定，您同意严格遵守以下义务："
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "a)不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v("b)从中国大陆向境外传输资料信息时必须符合中国有关法规。")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "c)不得利用本网站从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "d)不得干扰本网站的正常运转，不得侵入本网站及国家计算机信息系统；"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "e)不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "f)不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v("g)不得教唆他人从事本条所禁止的行为。")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "h)不得发布任何侵犯他人隐私、个人信息、著作权、商标权等知识产权或合法权利的内容。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "2、您须对自己在网上的言论和行为承担法律责任，您若在本网站上散布和传播反动、色情或其它违反国家法律的信息，本网站的系统记录有可能作为您违反法律的证据"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "3、除非法律允许或飞鹤书面许可，您使用本网站过程中不得从事下列行为："
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v("a)删除本网站及其副本上关于著作权的信息。")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "b)对本网站进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本网站的源代码。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "c)对飞鹤拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "d)对本网站或者本网站运行过程中释放到任何终端内存中的数据、网站运行过程中客户端与服务器端的交互数据，以及本网站运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经我们授权的第三方工具/服务接入本网站和相关系统。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "e)通过修改或伪造网站运行中的指令、数据，增加、删减、变动网站的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "f)通过非飞鹤开发、授权的第三方软件、插件、外挂、系统，登录或使用本网站及服务，或制作、发布、传播上述工具。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con", staticStyle: { "text-indent": "40px" } }, [
        _vm._v(
          "g)自行或者授权他人、第三方软件对本网站及其组件、模块、数据进行干扰。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rulename" }, [
      _c("h4", { staticClass: "small_title" }, [_vm._v("八、违约责任")]),
      _vm._v(" "),
      _c("p", { staticClass: "content" }),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "1、如果我们发现或收到他人举报投诉您违反本协议约定或存在任何恶意行为的，我们有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁、注销等处罚，并公告处理结果。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "2、我们有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "3、您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；我们因此遭受损失的，您也应当一并赔偿。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "4、除非另有明确的书面说明,我们不对本网站的运营及其包含在本网站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。"
        )
      ]),
      _vm._v(" "),
      _c("p")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rulename" }, [
      _c("h4", { staticClass: "small_title" }, [_vm._v("九、解释权")]),
      _vm._v(" "),
      _c("p", { staticClass: "content" }),
      _vm._v(" "),
      _c("p", { staticClass: "con" }, [
        _vm._v(
          "本注册协议的解释权归飞鹤公司及飞鹤电商所有，如其中任何条款与国家法律法规相抵触，则以国家法律法规的规定为准。"
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-642c5656", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-642c5656","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/registerAgreement.vue
// module id = null
// module chunks = 